<template>
  <div class="vipPrivilege">
    <!-- 标题栏 -->
    <van-nav-bar left-arrow title="VIP特权" @click-left="onClickLeft" />
    <!-- content -->
    <div class="page">
      <div class="BGurl-vip-privilege-bg">
        <div class="privilege-info">
          <img src="img/user/vip_privilege/img_vip.png" />
          <span>尊享会员</span>
          <div class="bgC-554637">
            已使用2日 余363日
          </div>
        </div>
      </div>
      <div class="privilege-content">
        <div class="privilege-divider">
          <img src="img/user/vip_privilege/line.png" class="trans-180" />
          <span>会员专属特权</span>
          <img src="img/user/vip_privilege/line.png" />
        </div>
        <div class="privilege-list">
          <div class="privilege-list-item">
            <img src="img/user/vip_privilege/img_01.png" />
            <span>音频畅听</span>
          </div>
          <div class="privilege-list-item">
            <img src="img/user/vip_privilege/img_02.png" />
            <span>1天仅需1元</span>
          </div>
          <div class="privilege-list-item">
            <img src="img/user/vip_privilege/img_03.png" />
            <span>导师课程</span>
          </div>
        </div>
      </div>
      <div class="kqb-submit">
        <button class="kqb-btn kqb-btn-block" @click="pageJump" :data-uri="'/vipPrivilegePayment'">
          会员续费
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vipPrivilege',
  data () {
    return {
    }
  },
  created () {

  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    // 页面跳转
    pageJump (e) {
      console.log(e)
      const thisObj = this
      let uri = e.target.dataset.uri
      let queryData = {}
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    }
  }
}
</script>
<style scoped>
.BGurl-vip-privilege-bg {
  height: 444px;
}

.privilege-info {
  padding: 90px 0 0 0;
  text-align: center;
}

.privilege-info img {
  max-width: 123px;
  height: 123px;
  margin: 0 auto 38px auto;
}

.privilege-info span {
  font-size: 40px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(83, 68, 53, 1);
}

.privilege-info .bgC-554637 {
  width: 377px;
  height: 65px;
  line-height: 65px;
  margin: 38px auto 0 auto;
  text-align: center;
  font-size: 30px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 210, 127, 1);
  border-radius: 33px;
}

.privilege-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 99px 0 54px 0;
}

.privilege-divider img {
  max-width: 52px;
  height: 20px;
}

.privilege-divider img.trans-180 {
  transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  /* IE 9 */
  -moz-transform: rotate(180deg);
  /* Firefox */
  -webkit-transform: rotate(180deg);
  /* Safari 和 Chrome */
  -o-transform: rotate(180deg);
  /* Opera */
}

.privilege-divider span {
  display: block;
  margin: 0 15px;
  font-size: 32px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  background: transparent;
}

.privilege-list {
  display: flex;
}

.privilege-list-item {
  flex-grow: 1;
  text-align: center;
}

.privilege-list-item img {
  max-width: 70px;
  height: 70px;
  margin: 0 auto 16px auto;
}

.privilege-list-item span {
  font-size: 26px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(120, 72, 47, 1);
}

.kqb-submit {
  position: fixed;
  bottom: 66px;
  padding: 0 47px;
}

.kqb-btn-block {
  width: 100%;
  height: 90px;
  line-height: 90px;
  margin: 0;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(120, 72, 47, 1);
  background: linear-gradient(
    90deg,
    rgba(219, 178, 146, 1) 0%,
    rgba(248, 223, 196, 1) 100%
  );
  /* box-shadow: 0px 3px 18px 0px rgba(0, 0, 0, 0.24); */
  border-radius: 45px;
}

.kqb-btn.button-hover {
  border-color: transparent;
}
</style>
